import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

import {
  AiFillGithub,
  AiOutlineMail,
} from "react-icons/ai";

import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>

        <Row>

          <Col md={8} className="home-about-description">

            <h1
              style={{
                fontSize: "2.6em",
                textAlign: "start",
              }}
            >
              LET ME{" "}
              <span className="purple">
                INTRODUCE
              </span>{" "}
              MYSELF
            </h1>

            <p className="home-about-body">

              I'm a{" "}
              <span className="purple">
                Full Stack Software Engineer
              </span>{" "}
              with professional experience building scalable web and desktop
              applications from the ground up.

              <br />
              <br />

              My expertise includes developing modern frontend applications,
              designing REST APIs, building backend services, integrating
              relational databases, and deploying production-ready software.

              <br />
              <br />

              <span className="purple">
                Frontend:
              </span>{" "}
              React.js, Next.js, Electron.js , Three.js, Redux Toolkit, React Query, Tailwind CSS, Material UI, HTML5, CSS3, SCSS, shadcn ui , Headless ui , Ant Desing and more.


              <br />
              <br />

              <span className="purple">
                Backend:
              </span>{" "}
              Node.js, Express.js, Flask Python , REST APIs

              <br />
              <br />

              <span className="purple">
                Databases:
              </span>{" "}
              PostgreSQL, Prisma ORM, SQLite3  MongoDB, Supabase, FIrebase.

              <br />
              <br />

              <span className="purple">
                Tools:
              </span>{" "}
              Git, GitHub, Jira, Figma, Vercel, Netlify, Render , cPanel , S3 , Ec2

              <br />
              <br />

              I'm passionate about writing clean, maintainable code,
              performance optimization, reusable architectures, and solving
              real-world engineering problems.
            </p>

          </Col>

          <Col md={4} className="myAvtar">

            <Tilt>

              <img
                src={myImg}
                className="img-fluid"
                alt="avatar"
              />

            </Tilt>

          </Col>

        </Row>

        <Row>

          <Col md={12} className="home-about-social">

            <h1 style={{ marginTop: "40px" }}>
              <span>GET IN </span>
              <span className="purple">TOUCH</span>
            </h1>

            <p
              style={{
                maxWidth: "900px",
                margin: "20px auto",
                fontSize: "18px",
              }}
            >
              I'm always interested in discussing software engineering,
              full-stack development, freelance projects, open-source
              collaboration, and exciting new opportunities.

              <br />
              <br />

              Let's build something great together.
            </p>

            <ul className="home-about-social-links">

              <li className="social-icons">
                <a
                  href="https://github.com/muhammad-ismaeel-9"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="mailto:m.ismaeel.dev@gmail.com"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/muhammad-ismaeel-461355251"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

            </ul>

          </Col>

        </Row>

      </Container>
    </Container>
  );
}

export default Home2;